<script setup lang="ts">
  import { UserAvatar } from '@/shared/ui';
  import NotificationItem from './NotificationItem.vue';
  import type { NotificationDisplay } from '@/shared/lib';

  defineProps<{
    notifications: NotificationDisplay[];
    isLoading?: boolean;
    processingNoticeId?: number | null;
  }>();

  const emit = defineEmits<{
    (e: 'acknowledge', id: number): void;
    (e: 'navigate'): void;
  }>();
</script>

<template>
  <div class="overflow-y-auto pb-2">
    <p
      v-if="notifications.length === 0 && isLoading"
      class="px-3 py-6 text-center text-sm text-gray-03"
    >
      Carregando avisos...
    </p>
    <p
      v-else-if="notifications.length === 0"
      class="px-3 py-6 text-center text-sm text-gray-03"
    >
      Nenhum aviso disponível no momento.
    </p>
    <div
      v-else
      class="divide-y divide-gray-02 pr-4"
    >
      <p
        v-if="isLoading"
        class="px-3 pb-2 text-xs text-gray-03"
      >
        Atualizando avisos...
      </p>
      <div
        v-for="notification in notifications"
        :key="notification.id"
        class="flex items-start gap-3 py-4"
      >
        <UserAvatar
          :name="notification.name"
          class="mt-0.5"
        />
        <NotificationItem
          :notification="notification"
          :is-acknowledge-pending="processingNoticeId === notification.id"
          @acknowledge="emit('acknowledge', $event)"
          @navigate="emit('navigate')"
        />
      </div>
    </div>
  </div>
</template>
